const BLOCK_TAGS = 'p|div|ul|ol|li|h[1-6]|blockquote|table|thead|tbody|tfoot|tr|td|th|section|article'

const BLANK_CONTENT = '(?:\\s|&nbsp;|&#160;|&#xa0;|\\u00a0|<br\\s*/?>)*'

const EMPTY_BLOCK = new RegExp(`<(p|div)(?:\\s[^>]*)?>${BLANK_CONTENT}</\\1\\s*>`, 'gi')
const LEADING_BLANK = new RegExp(`^${BLANK_CONTENT}`, 'i')
const TRAILING_BLANK = new RegExp(`${BLANK_CONTENT}$`, 'i')
const BLOCK_TAG_PADDING = new RegExp(`\\s*(</?(?:${BLOCK_TAGS})(?:\\s[^>]*)?>)\\s*`, 'gi')
const BLANK_AFTER_OPENING_BLOCK = new RegExp(`(<(?:p|div|li)(?:\\s[^>]*)?>)${BLANK_CONTENT}`, 'gi')
const BLANK_BEFORE_CLOSING_BLOCK = new RegExp(`${BLANK_CONTENT}(</(?:p|div|li)\\s*>)`, 'gi')

/**
 * Cleans analyst-authored HTML before it is shown in a tooltip.
 *
 * The tooltip surface renders with `white-space: pre-line`, so a newline between
 * two block tags is drawn as a blank line, and empty `<p></p>` / `<div></div>`
 * wrappers or `<br>` runs at the ends add further vertical gap. This removes
 * whitespace around block tags, drops empty paragraphs and wrappers (including
 * ones that only contain whitespace, `&nbsp;` or `<br>`), and trims the ends.
 * Text content is not changed.
 */
export function trimTooltipHtml(html: string | null | undefined): string {
  if (!html) return ''

  let result = html.replace(/\r\n?/g, '\n').replace(BLOCK_TAG_PADDING, '$1')

  let previous: string
  do {
    previous = result
    result = result.replace(EMPTY_BLOCK, '')
  } while (result !== previous)

  return result.replace(BLANK_AFTER_OPENING_BLOCK, '$1').replace(BLANK_BEFORE_CLOSING_BLOCK, '$1').replace(LEADING_BLANK, '').replace(TRAILING_BLANK, '').trim()
}
